import axios from "axios";
import {
  STRAPI_DEV_URL,
  STRAPI_PROD_URL,
} from "../../../services/strapi-content/strapiContent.constants";

export default {
  state: {
    documentItems: [],
  },
  mutations: {
    SET_DOCUMENT_ITEMS(state, payload) {
      state.documentItems = payload.documentItems;
    },
  },
  getters: {
    getdocumentItems: (state) => state.documentItems,
  },
  actions: {
    // Fetch glossary items from Strapi API using axios
    async fetchAllDocumentItems(context, payload) {
      const enviroment =
        process.env.VUE_APP_ENV === "development"
          ? STRAPI_DEV_URL
          : STRAPI_PROD_URL;
      try {
        const response = await axios.get(`${enviroment}${payload.link}`);
        return response;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
